module.exports = __webpack_public_path__ + "static/the-case-against-socialism-25b7209c268073be54acd8ea74ae436d.jpg";